export interface EntityState<T = unknown> {
  ids: string[];
  entities: Record<string, T>;
}

export function createInitialEntityState<T>(): EntityState<T> {
  return {
    ids: [],
    entities: {},
  };
}
